// Module
var code = "<div class=\"item-component\"> <div :id=\"id\" class=\"themed-grid-lbl ml-0\"> <label>{{ label }}</label> <hot-table :settings=\"hotSettings\"></hot-table> </div> </div>";
// Exports
export default code;